import { useModal } from '@/contexts/ModalProvider';
import ConfirmDialog from '@/components/modals/ConfirmDialog';

const ModalLayout = () => {
  const { modals } = useModal();

  return (
    <>
      {modals.confirm && <ConfirmDialog />}
    </>
  );
};

export default ModalLayout;
